import React from "react";
import { NavLink } from "react-router-dom";
import {
    AccordionItem,
    AccordionItemPanel,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemState,
} from "react-accessible-accordion";
const traslados = require("assets/img/icons/traslados.png");
const traslados_activo = require("assets/img/icons/traslados_activo.png");

export const TrasladosItem = ({
    permisos,
    proveedor,
    proveedor_admin,
    location,
    moduloId,
    isItemSelected,
}) => {
    if (!permisos) return null;
    if (
        !permisos.traslados_envio &&
        !permisos.traslados_recepcion &&
        !permisos.traslados_reporte
    )
        return null;
    if (proveedor === true || proveedor_admin === true) return null;

    return (
        <div className="nav-item">
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <AccordionItemState>
                            {({ expanded }) => {
                                const isSelected = isItemSelected(
                                    moduloId,
                                    location.hash,
                                    expanded,
                                );
                                return (
                                    <div
                                        className={`nav-link ${isSelected ? "active" : ""}`}
                                    >
                                        <img
                                            src={
                                                isSelected
                                                    ? traslados_activo
                                                    : traslados
                                            }
                                            className="icon-menu"
                                            alt=""
                                        />
                                        TRASLADOS
                                    </div>
                                );
                            }}
                        </AccordionItemState>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemState>
                    {({ expanded }) => {
                        const isSelected = isItemSelected(
                            moduloId,
                            location.hash,
                            expanded,
                        );
                        return (
                            isSelected && (
                                <AccordionItemPanel
                                    className={
                                        isSelected ? "acordion-expanded" : ""
                                    }
                                >
                                    <div className="pb-2">
                                        {permisos.traslados_envio &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/traslados-envio"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/traslados-envio",
                                                            )
                                                        }
                                                    >
                                                        ENVÍOS
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.traslados_recepcion &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/traslados-recepcion"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/traslados-recepcion",
                                                            )
                                                        }
                                                    >
                                                        RECEPCIONES
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.traslados_reporte &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/reporte-traslados"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/reporte-traslados",
                                                            )
                                                        }
                                                    >
                                                        REPORTE
                                                    </NavLink>
                                                </div>
                                            )}
                                    </div>
                                </AccordionItemPanel>
                            )
                        );
                    }}
                </AccordionItemState>
            </AccordionItem>
        </div>
    );
};
